export default __webpack_public_path__ + "static/media/Bed.31f17c6b.svg";